module.exports = __webpack_public_path__ + "assets/img/home_process1.f7a40533.png";